import React from 'react'
import { cn } from '~/lib/utils'
const SelectStatusIndicator = ({
  Icon,
  className,
  color,
  filled = false,
  fullWidth = false,
  children,
}) => {
  const green = cn(
    'text-intoo-green-medium border-willow-brook-400',
    filled ? 'bg-willow-brook-100' : 'bg-white',
  )

  const blue = cn(
    'text-intoo-blue-medium border-intoo-blue-primary-400',
    filled ? 'bg-intoo-blue-medium-100' : 'bg-white',
  )

  const gray = cn(
    'text-mine-shaft-500 border-mine-shaft-200',
    filled ? 'bg-mine-shaft-50' : 'bg-white',
  )

  const getColors = () => {
    if (color === 'green') {
      return green
    } else if (color === 'blue') {
      return blue
    } else {
      return gray
    }
  }

  const colorClasses = getColors()
  const iconColor = color ? `text-${color}` : 'text-mine-shaft-500'

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-[10px] border p-2 text-sm',
        fullWidth ? 'w-full' : 'w-fit',
        colorClasses,
        className,
      )}
    >
      {Icon && <Icon className={cn(iconColor, 'h-4 w-4')} />}
      {children}
    </div>
  )
}

export default SelectStatusIndicator
